/* eslint-disable */
// TODO: Lint cleanup. If you are editing this file, it is your duty to fix all linting errors.
import t from './actionTypes.js'

export const loadPersonList = (payload) => ({
  type: t.LOAD_PERSON_LIST,
  payload,
})
